<div class="d-flex justify-content-between px-3 pt-3 pb-0" >
  <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Add Tags</h5>
  <span type="button" class="" 
    (click)="dismiss()">
    <i class="fas fa-times f-14"></i>
</span>
</div>
<div class="modal-body ">
  <div class="mb-2">
    <div class="">
        <div class="custom-input mb-3">
          <input data-testid="auto-app-candidate-tags-input-1" type="search" class="wc-form-control nobg" (click)="searchTags($event.target.value)" (input)="searchTags($event.target.value)"
          placeholder="Enter Tag" [(ngModel)]="tagText" (keyup.enter)="createTag($event.target.value);" [matAutocomplete]="tag_auto">
          <mat-autocomplete #tag_auto="matAutocomplete">
            <mat-option *ngFor="let tagData of tags" (onSelectionChange)="addTag(tagData);">{{tagData.tagtext}}</mat-option>
            </mat-autocomplete>
          <!-- <div *ngIf="tagText != ''" class="buttons">
              <div class="check-btn" (click)="createTag(tagText);">
                  <i class="far fa-check"></i>
              </div>
          </div> -->
          <!-- <p class="text-danger f-12" *ngIf="tagerror">{{tagerror}}</p> -->
        </div>

    </div>
    <span *ngFor="let tag of tagchips;let i = index" class="wc-ats-chip mr-1 mb-1 d-inline-flex"> {{tag?.tagtext}} <span class="ml-2 pointer" (click)="unselect(tag.tagid)" > <i
        class="fal fa-times"></i></span></span>
  </div>
  <span class="mb-0 f-12 text-danger">{{tagErrorMessage}}</span>
    <div class="d-flex">
      <button data-testid="auto-app-candidate-tags-button-1" class="btn-trms-small ml-auto" [disabled]="addTagSpinner" (click)="doneFunction()">
        <span [ngClass]="{ 'spinner-border text-light spinner-size': addTagSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addTagSpinner }">
          {{addTagSpinner ? '' : 'Save'}}
        </span>
      </button>
    </div>
</div>
